import gql from 'graphql-tag'

export const fetchOfficesSelect = delegation_id => ({
	query: gql`
		query ($delegation_id: bigint!) {
			offices: organizations_offices(
				where: { delegation_id: { _eq: $delegation_id } }
			) {
				id
				office_name
			}
		}
	`,
	variables: { delegation_id },
	skip: delegation_id == null
})
